import {
  BufferGeometry,
  Color,
  Float32BufferAttribute,
  LineBasicMaterial,
  LineSegments,
  Scene,
  Vector3,
} from 'three';
import { Outside } from './outside';
import { Session } from '../../core/types';
import * as _ from 'lodash';

export class Ground {
  private space = 10000;
  private readonly COLOR: Color = new Color(0xcfcdcd);
  private readonly MATERIAL: LineBasicMaterial = new LineBasicMaterial({
    color: this.COLOR,
    depthTest: true,
    depthWrite: false,
    polygonOffset: true,
    polygonOffsetFactor: -4,
  });

  public draw(scene: Scene, outside: Outside, session: Session): LineSegments {
    if (session.unit === 'lb') {
      this.space = 3600;
    }
    const multiplier = 2;
    const dimensions =
      outside.dimensions.width > outside.dimensions.length
        ? outside.dimensions.width * multiplier
        : outside.dimensions.length * multiplier;
    let vertices = [];
    vertices = vertices.concat(
      this.calculateVerticesForHorizontalLines(dimensions, dimensions, this.space),
    );
    vertices = vertices.concat(
      this.calculateVerticesForVerticalLines(dimensions, dimensions, this.space),
    );
    const geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    const grid = new LineSegments(geometry, this.MATERIAL);
    const truckLength = session.truck.set
      ? session.truck.length + session.truck.length1
      : session.truck.length;
    const objectOffsetX = (session.truck.width * 100) / 2;
    const objectOffsetZ = (truckLength * 100) / 2;
    const xDimension = -dimensions / 2 + objectOffsetX;
    const zDimension = -dimensions / 2 + objectOffsetZ;
    const xDim = _.round(xDimension / this.space, 0) * this.space;
    const zDim = _.round(zDimension / this.space, 0) * this.space;
    const position = new Vector3(xDim, -0.005, zDim);
    const gridSelect = scene.getObjectByName('Ground');
    scene.remove(gridSelect);
    grid.position.copy(position);
    grid.name = 'Ground';
    scene.remove(grid);
    scene.add(grid);
    return grid;
  }

  private calculateVerticesForHorizontalLines(
    lineLength: number,
    axisLength: number,
    space: number,
  ): number[] {
    const vertices = [];
    for (let i = 0; axisLength - space * i >= 0; i++) {
      vertices.push(0, 0, i * space, lineLength, 0, i * space);
    }
    return vertices as number[];
  }

  private calculateVerticesForVerticalLines(
    lineLength: number,
    axisLength: number,
    space: number,
  ): number[] {
    const vertices = [];
    for (let i = 0; axisLength - space * i >= 0; i++) {
      vertices.push(i * space, 0, 0, i * space, 0, lineLength);
    }
    return vertices as number[];
  }
}
